// extracted by mini-css-extract-plugin
export default {"category":"category_category__LHOgt","category__container":"category_category__container__cFYVw"};